import React, { useState } from 'react';
import { IconBike, IconDeviceTv } from '@tabler/icons-react';
import zwiftLogo from '../assets/logos/zwift_logo_white.png';
import rouvyLogo from '../assets/logos/rouvy_logo.svg';
import mywhooshLogo from '../assets/logos/mywhoosh_logo.png';
import './MultiPlatformGallery.css';

// Platform status: Zwift is live (2D and 3D); Rouvy and MyWhoosh are on the roadmap.
// Banners are plain gradients with the official platform logos (white variants)
// bundled locally and an icon fallback if a logo fails to render.
const CARDS = [
  {
    key: 'zwift',
    badge: 'Live',
    badgeVariant: 'live',
    icon: <IconBike size={22} />,
    logo: zwiftLogo,
    logoAlt: 'Zwift logo',
    title: 'Zwift',
    blurb: 'Every Zwift ride lands on Strava with the real world map, in 2D and 3D.',
    bullets: ['All Zwift worlds', 'Auto-fixed on Strava'],
    grad: 'linear-gradient(135deg, #fc6719, #b64005)',
  },
  {
    key: 'rouvy',
    badge: 'Coming soon',
    badgeVariant: 'soon',
    icon: <IconDeviceTv size={22} />,
    logo: rouvyLogo,
    logoAlt: 'Rouvy logo',
    title: 'Rouvy',
    blurb: 'Your AR routes, rebuilt as the real-world roads you rode. Next on the roadmap.',
    bullets: ['In development', 'Same one-tap auto-fix'],
    grad: 'linear-gradient(135deg, #1f7a4d, #0c4a30)',
  },
  {
    key: 'mywhoosh',
    badge: 'Coming soon',
    badgeVariant: 'soon',
    icon: <IconBike size={22} />,
    logo: mywhooshLogo,
    logoAlt: 'MyWhoosh logo',
    title: 'MyWhoosh',
    blurb: 'MyWhoosh worlds on the proper map, not the ocean. Coming soon.',
    bullets: ['In development', 'Same one-tap auto-fix'],
    grad: 'linear-gradient(135deg, #1d4ed8, #0b2a73)',
  },
];

const PlatformVisual = ({ card }) => {
  const [logoFailed, setLogoFailed] = useState(false);
  return (
    <div className="mpg-visual" style={{ background: card.grad }}>
      <span className={`mpg-badge${card.badgeVariant === 'soon' ? ' mpg-badge-soon' : ''}`}>
        {card.badge}
      </span>
      {card.logo && !logoFailed ? (
        <img
          src={card.logo}
          alt={card.logoAlt}
          className="mpg-visual-logo"
          onError={() => setLogoFailed(true)}
        />
      ) : (
        <span className="mpg-visual-icon">{card.icon}</span>
      )}
    </div>
  );
};

const MultiPlatformGallery = () => (
  <div className="section-darker mpg-section">
    <div className="section-inner">
      <div className="section-header-centered">
        <h2>Live for Zwift. Rouvy and MyWhoosh are next.</h2>
        <p className="mpg-sub">We fix Zwift rides today, in 2D and 3D. Rouvy and MyWhoosh support is coming soon.</p>
      </div>
      <div className="mpg-grid">
        {CARDS.map((c) => (
          <div className="mpg-card" key={c.key}>
            <PlatformVisual card={c} />
            <div className="mpg-body">
              <h3>{c.title}</h3>
              <p>{c.blurb}</p>
              <ul>
                {c.bullets.map((b) => <li key={b}>{b}</li>)}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default MultiPlatformGallery;
